import {Component, Inject, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {WINDOW} from "@biletix/core/common";
import {RouterService} from "@biletix/core/services/router.service";
import {environment} from "@biletix/env";
import {StatusCodeResponseService} from "@biletix/core/services/status-code-response.service";

@Component({
    standalone: false,
    selector: 'btx-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
    invalidPath: string = '';

    constructor(@Inject(WINDOW) private window: Window,
                private routerService: RouterService,
                private statusCodeResponseService: StatusCodeResponseService,
            private router: Router) {


        //TODO: Şimdilik seam tarafına yönledirildi.
        //this.onNavigate();
    }

    ngOnInit(): void {
      this.invalidPath = this.router.url;

      // Bu bileşen yakalanamayan rotalar için render ediliyor; gövde bir hata
      // sayfası olduğu halde yanıt 200 dönüyordu (yumuşak 404). Arama motorları
      // 200 gördüğü sürece bu URL'leri index'te tutar.
      this.statusCodeResponseService.setNotFound();
    }

    onNavigate() {
        this.window.location.href = environment.biletixWebHost + '/404-html/404.html';
    }

}
